import { ButtonRestrictionType } from '../common/enumerations/button-restriction-type';
import { IElectronicJournalRecord } from '../common/interfaces/states/IElectronicJournalRecord';
import { store } from '../common/redux/configure-store';
import { voidCouponLineItem } from '../coupons/business-logic/void-coupon-line-item';
import { cancelItem } from '../home-page/business-logic/cancel-line-or-item';
import { cancelTenderPayment } from '../home-page/business-logic/cancel-tender-payment';
import { popupMessage } from '../messages/business-logic/popup-message';
import {
  initialExtendedPriceOverride,
  initialPriceOverride,
} from '../price-override/business-logic/handle-price-override';
import { handleTareModification } from '../tare-weight-items/business-logic/handle-tare-modification';
import { handleVoidByCode } from '../void-by-code/business-logic/handle-void-by-code';
import { verifyItem } from './menu-mapping-helper';

interface IActionWindowCommands {
  [key: string]: {
    onClick: (() => Promise<void>) | (() => void);
    appliesTo?: ButtonRestrictionType[];
  };
}

const getSelectedItem = (): IElectronicJournalRecord | undefined => {
  const { ejItems } = store.getState().itemList;
  return ejItems.find(item => item.Selected);
};

const tareModifcationButtonAction = (): void => {
  const item = getSelectedItem();
  if (item) {
    handleTareModification(item).catch(popupMessage);
  }
};

const cancelTenderButtonAction = (): void => {
  const item = getSelectedItem();
  if (item) {
    cancelTenderPayment(item.SequenceNumber).catch(popupMessage);
  }
};

const voidCouponButtonAction = (): void => {
  const item = getSelectedItem();
  if (item) {
    voidCouponLineItem(item.SequenceNumber).catch(popupMessage);
  }
};

export const actionWindowCommands: IActionWindowCommands = {
  CancelItemFromLineItemCommand: {
    onClick: cancelItem,
    appliesTo: [
      ButtonRestrictionType.Product,
      ButtonRestrictionType.QuantityGreaterThan1,
      // TODO:ButtonRestrictionType.ReturnItem,  commenting this line since void item is not supported for return items.  Please uncomment it once it is supported
    ],
  },
  CancelLineItemCommand: {
    onClick: verifyItem,
    appliesTo: [ButtonRestrictionType.Product, ButtonRestrictionType.ReturnItem],
  },
  EnhancedPriceOverrideCommand: {
    onClick: initialExtendedPriceOverride,
    appliesTo: [ButtonRestrictionType.Product, ButtonRestrictionType.ReturnItem],
  },
  PriceOverrideCommand: {
    onClick: initialPriceOverride,
    appliesTo: [ButtonRestrictionType.Product, ButtonRestrictionType.ReturnItem],
  },
  SetCancelItemStateCommand: {
    onClick: handleVoidByCode,
    appliesTo: [
      ButtonRestrictionType.Product,
      // TODO:ButtonRestrictionType.ReturnItem,  commenting this line since void item is not supported for return items.  Please uncomment it once it is supported
    ],
  },
  PreSalePriceOverrideCommand: {
    onClick: () => {},
  },
  ModifyTareCommand: {
    onClick: tareModifcationButtonAction,
    appliesTo: [ButtonRestrictionType.Product],
  },
  VoidTenderCommand: {
    onClick: cancelTenderButtonAction,
    appliesTo: [ButtonRestrictionType.Tender],
  },
  CancelCouponLineCommand: {
    onClick: voidCouponButtonAction,
    appliesTo: [ButtonRestrictionType.Coupon],
  },
  CouponRewardOverrideCommand: {
    onClick: () => {},
    // Per Monica's request - disabled since this function hasn't been implemented
    // appliesTo: [EJRecordTypes.coupon],
  },
};
